export const LockIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_8204_14638)'>
      <path
        d='M12.6663 5.33317H11.9997V3.99984C11.9997 2.15984 10.5063 0.666504 8.66634 0.666504C6.82634 0.666504 5.33301 2.15984 5.33301 3.99984V5.33317H4.66634C3.93301 5.33317 3.33301 5.93317 3.33301 6.6665V13.3332C3.33301 14.0665 3.93301 14.6665 4.66634 14.6665H12.6663C13.3997 14.6665 13.9997 14.0665 13.9997 13.3332V6.6665C13.9997 5.93317 13.3997 5.33317 12.6663 5.33317ZM8.66634 11.3332C7.93301 11.3332 7.33301 10.7332 7.33301 9.99984C7.33301 9.2665 7.93301 8.6665 8.66634 8.6665C9.39967 8.6665 9.99967 9.2665 9.99967 9.99984C9.99967 10.7332 9.39967 11.3332 8.66634 11.3332ZM10.733 5.33317H6.59967V3.99984C6.59967 2.85984 7.52634 1.93317 8.66634 1.93317C9.80634 1.93317 10.733 2.85984 10.733 3.99984V5.33317Z'
        fill='#64748B'
      />
    </g>
    <defs>
      <clipPath id='clip0_8204_14638'>
        <rect width='16' height='16' fill='white' transform='translate(0.666504)' />
      </clipPath>
    </defs>
  </svg>
);
